import React, { useState, useEffect } from "react";
import { Button, message, Layout, Card, Table } from "antd";
import "./style.scss";
import { LeftOutlined } from "@ant-design/icons";
import OrderService from "../../services/OrderService";
import { useHistory } from "react-router";

import { Content, Footer } from "antd/lib/layout/layout";
import Spinner from "../../components/Layout/Spinner";

const columns = [
  {
    title: "Item",
    render: (item) => {
      return (
        <div>
          <img
            style={{ height: "50px", marginRight: "10px" }}
            src={item.menu_item.photo_url}
            alt={`order-${item.id}`}
          />{" "}
          {item.name}
        </div>
      );
    },
  },
  {
    title: "Name",
    render: (item) => (
      <a href={`/menus/${item.menu_item.id}/menu-items/${item.menu_item.id}`}>
        {item.menu_item.name}
      </a>
    ),
  },
  {
    title: "Quantity",
    dataIndex: "quantity",
    key: "quantity",
  },
  {
    title: "Price",
    dataIndex: "price",
    key: "price",
    render: (price) => `$${price}`,
  },
];

export default function CateringDetails(props) {
  const [isSpin, setSpin] = useState(false);
  const [updatedCatering, setUpdatedCatering] = useState();
  const history = useHistory();

  useEffect(() => {
    getXateringdetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const approve = async (values) => {
    setSpin(true);
    await OrderService.approveCaterings(props.updatedCatering.id);
    message.success("Approved Successfully");

    setSpin(false);
    props.closeModal(false);
  };

  const getXateringdetails = async (values) => {
    const id = props.match.params.cateringId;
    setSpin(true);
    const data = await OrderService.getCateringDetails(id);
    setUpdatedCatering(data);

    setSpin(false);
  };

  return (
    <Layout>
      <Content style={{ background: "white", flex: "unset" }}>
        <div style={{ background: "white" }}>
          <span className="back-btn" onClick={() => history.push(`/catering`)}>
            <LeftOutlined /> Back to Catering
          </span>
        </div>
        {updatedCatering && (
          <>
            <Card title="Customer">
              <div className="catering-value">
                {updatedCatering.customer.name}
              </div>
              <div className="catering-value">
                {updatedCatering.customer.email}
              </div>
              <div className="catering-value">
                {updatedCatering.customer_location.address_field1 +
                  " " +
                  updatedCatering.customer_location.address_field2}
              </div>
              <div className="catering-value">
                {updatedCatering.customer_location.city}
              </div>
              <div className="catering-value">
                {updatedCatering.customer_location.country}
              </div>
              <div className="catering-value">
                {updatedCatering.customer_location.postal_code}
              </div>
            </Card>
            <Card title="Restaurant">
              <div className="catering-value">
                {updatedCatering.restaurant.name}
              </div>
              <div className="catering-value">
                {updatedCatering.restaurant.email}
              </div>
              <div className="catering-value">
                {updatedCatering.restaurant.address}
              </div>
              <div className="catering-value">
                {updatedCatering.restaurant.phone}
              </div>
            </Card>
            <Card>
              <div className="catering-item">
                <div className="catering-name">Created Date: </div>
                <div className="catering-value">
                  {updatedCatering.created_at}
                </div>
              </div>
              {updatedCatering.approval_date && (
                <div className="catering-item">
                  <div className="catering-name">Approved Date: </div>
                  <div className="catering-value">
                    {updatedCatering.approval_date}
                  </div>
                </div>
              )}
              <div className="catering-item">
                <div className="catering-name">Time Zone:</div>
                <div className="catering-value">
                  {updatedCatering.time_zone}
                </div>
              </div>
              <div className="catering-item">
                <div className="catering-name">Pickup Date:</div>
                <div className="catering-value">
                  {updatedCatering.catering_pickup_date}
                </div>
              </div>
              <div className="catering-item">
                <div className="catering-name">Status:</div>
                <div
                  className="catering-value"
                  style={{
                    color: updatedCatering.is_approved ? "#52c41a" : "#e18b8b",
                  }}
                >
                  {updatedCatering.is_approved
                    ? "Approved"
                    : "Waiting for Approval"}
                </div>
              </div>
              <div className="catering-item">
                <div className="catering-name">Event Details: </div>
                <div className="catering-value">
                  {updatedCatering.event_details}
                </div>
              </div>
              <div className="catering-item">
                <div className="catering-name">Event Time: </div>
                <div className="catering-value">
                  {updatedCatering.event_time}
                </div>
              </div>
              <div className="catering-item">
                <div className="catering-name">Event Type: </div>
                <div className="catering-value">
                  {updatedCatering.event_type}
                </div>
              </div>
              <br />
              <br />
              <Table columns={columns} dataSource={updatedCatering.items} />
            </Card>
          </>
        )}
        {isSpin && <Spinner />}
      </Content>
      <Footer className="catering-footer">
        {/* <Button className="reject-btn" type="primary" danger >Reject</Button> */}
        {updatedCatering && !updatedCatering.is_approved && (
          <Button onClick={() => approve()} type="primary">
            Approve
          </Button>
        )}
      </Footer>
    </Layout>
  );
}
